import { jsx as t } from "react/jsx-runtime";
import { DeletedContent as n } from "../../../DeletedContent/index.js";
import { RetractedContent as m } from "../../../RetractedContent/index.js";
const a = ({
  isDeleted: e,
  content: o,
  clickoutFunction: r
}) => e ? /* @__PURE__ */ t(n, {}) : /* @__PURE__ */ t(
  m,
  {
    content: o,
    clickoutFunction: r,
    maxLines: 1
  }
);
export {
  a as ParentcommentBodyContent
};
